import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class Fir5471ScheduleJService {

  constructor(private http: HttpClient) { }

  saveScheduleJ(
    baseUrl: string,
    scheduleSettings: any[],
    scheduleDetails: any,
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=34euhn`;

    const params = _.merge({}, globalParams, filterParams);
    params['jsonObj'] = JSON.stringify(scheduleDetails);
    params['jsonSettings'] = JSON.stringify(scheduleSettings);
    params['process_name'] = 'Schedule_J_Save';
    if (globalParams?.jcd_key === '' || globalParams?.jcd_key === undefined) {
      params['jcd_key'] = '250';
    }

    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        formData.append(key, params[key].toString());
      }
    });

    const options = {
      withCredentials: true
    };

    return this.http.post<any>(url, formData, options);
  }

  updateFlag(
    baseUrl: string,
    jsonSettings: any[],
    jsonDetails: any[],
    globalParams: any = {},
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=0wcwam`;

    const params = _.merge({}, globalParams, filterParams);
    params['jsonObj'] = JSON.stringify(jsonDetails);
    params['jsonSettings'] = JSON.stringify(jsonSettings);
    params['process_name'] = 'Schedule_J_updateFlag';
    if (globalParams?.jcd_key === '' || globalParams?.jcd_key === undefined) {
      params['jcd_key'] = '250';
    }

    const formData = new FormData();
    Object.keys(params).forEach(key => {
      if (params[key] !== null && params[key] !== undefined) {
        formData.append(key, params[key].toString());
      }
    });

    const options = {
      withCredentials: true
    };

    return this.http.post<any>(url, formData, options);
  }
}
